import React, { useState, useEffect } from "react"
import axios from "axios" // Import axios for API call
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap"

// validation Validation
import * as Yup from "yup"
// import { usevalidation } from "validation"
import { useFormik } from "formik"
//redux
import { useSelector, useDispatch } from "react-redux"

import withRouter from "components/Common/withRouter"

// actions

import { useLocation, useNavigate } from "react-router-dom"

import { ToastContainer, toast } from "react-toastify"
import DeleteModel from "./DeleteModel"

// import "react-toastify/dist/ReactToastify.css"

const durationProfile = () => {
  //meta title
  document.title = "Profile | Skote - React Admin & Dashboard Template"

  const dispatch = useDispatch()
  const location = useLocation()
  // const patientData = location.state?.patientData
  const navigate = useNavigate()

  const [durationData, setDurationData] = useState(
    location.state?.durationData || {},
  )
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: durationData.id,
      value: durationData?.value || "",
    },
    validationSchema: Yup.object().shape({
      value: Yup.string().required("Duration value is required"),
    }),
    onSubmit: async values => {
      console.log("Submitting values:", values)
      await updateDuration(values)
    },
  })

  const { isSubmitting } = validation
  console.log("valiadation error", validation?.errors)

  const updateDuration = async updatedData => {
    try {
      const authToken = localStorage.getItem("authToken")
      console.log("Sending updated data:", updatedData)

      const response = await API.put(
        `/duration/${updatedData.id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("Duration updated successfully ", { autoClose: 2000 })

        setTimeout(() => {
          navigate("/service-duration")
        }, 2000)
      } else {
        toast.error("Failed to update duration. Please try again.")
      }
    } catch (error) {
      console.error("Error updating duration data:", error)
      toast.error("Error updating duration.")
    }
  }

  const handleDelete = () => {
    if (!durationData || !durationData.id) {
      toast.error("Invalid duration data.")
      return
    }
    setShowDeleteModal(true) // open modal
  }

  // delete patient data
  const confirmDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken")

      const response = await API.delete(
        `/duration/${durationData.id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("Duration deleted successfully!", { autoClose: 2000 })
        setShowDeleteModal(false)
        setTimeout(() => {
          navigate("/service-duration")
        }, 2000)
      } else {
        toast.error("Failed to delete patient. Please try again.")
      }
    } catch (error) {
      console.error("Error deleting duration value:", error)
      toast.error("Error deleting duration value.")
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content p-0">
        <Container fluid>
          <h4 className="card-title mb-4">Change Duration Profile</h4>

          <Card>
            <CardBody>
              <form
                action=""
                className="form-horizontal"
                onSubmit={validation.handleSubmit}
              >
                <Row>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Value</Label>
                      <Input
                        name="value"
                        // value={name}
                        className="form-control"
                        placeholder="Value "
                        type="number"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.value || ""}
                        invalid={
                          validation.touched.value && validation.errors.value
                            ? true
                            : false
                        }
                      />
                      {validation.touched.value && validation.errors.value && (
                        <div className="text-danger">
                          {validation.errors.value}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <div
                  className="text-center mt-4"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContet: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="submit"
                    color="primary"
                    className="px-3 border"
                    disabled={isSubmitting}
                  >
                    Update Duration
                  </Button>
                  {/* <button onClick={() => updatePatient1(patientData)}>Update</button>   */}

                  <Button
                    type="button"
                    color="danger"
                    className="px-3 border"
                    onClick={handleDelete}
                  >
                    Delete Duration
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    className="px-3 border"
                    onClick={() => navigate("/service-duration")}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Container>
      </div>
      <DeleteModel
        isOpen={showDeleteModal}
        toggle={() => setShowDeleteModal(false)}
        entityName="duration"
        entityLabel={durationData?.value}
        onConfirm={confirmDelete}
      />
    </React.Fragment>
  )
}

export default withRouter(durationProfile)
